import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './NotFound.css';

export const NotFound: React.FC = () => {
  return (
    <div className="not-found-container">
      <Helmet>
        <title>Page Not Found | Bagshot Offices</title>
        <meta name="description" content="The page you are looking for does not exist. Return to Bagshot Offices homepage to view our small office units for rent." />
        <link rel="canonical" href="https://www.bagshot-offices.co.uk/404" />
      </Helmet>
      <div className="not-found-content">
        <span className="not-found-code">404</span>
        <h1 className="not-found-title">Page Not Found</h1>
        <p className="not-found-description">
          Sorry, the page you are looking for doesn't exist or has been moved.
        </p>
        <div className="not-found-cta-container">
          <Link to="/" className="not-found-button">Return to Home</Link>
          <Link to="/contact" className="not-found-button secondary">Contact Us</Link>
        </div>
      </div>
    </div>
  );
};
